export default "__VITE_ASSET__NbkdEInK__"